<!--考级中心 我的社群 添加用户-->
<template>
  <div class="" style="padding:.2rem 0 1rem 0">
    <van-cell title="用户选择" is-link value="请选择用户" @click="showUserPicker = true" v-if="!formData.user.length"/>

    <van-cell title="用户选择" is-link value="请选择用户" @click="showUserPicker = true" v-else>
      <template slot="default">
        <span class="selected">{{ formData.user[0].name }}</span>
      </template>
    </van-cell>


    <van-cell
        title="用户类型"
        is-link
        value="请选择用户类型"
        @click="showPicker = true"
    >
      <template slot="default">
        <span class="selected">{{ formData.typeName }}</span>
      </template>
    </van-cell>

    <div class="savebtn">
      <van-button color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                  style="width: 3rem" round
                  size="normal" v-if="!saveLoading" @click="onSubmit">保存
      </van-button>
      <van-button color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                  style="width: 3rem" round
                  size="normal" v-else>保存中...
      </van-button>
    </div>

    <van-popup v-model="showPicker" position="bottom">
      <van-picker
          show-toolbar
          :columns="typeColumns"
          @cancel="showPicker = false"
          @confirm="onConfirm"
      />
    </van-popup>

    <UserPicker
        :show="showUserPicker"
        :limit="1"
        :defaultValue="formData.user"
        @onChange="onUserChange"
        @onClose="showUserPicker=false"
        @onConfirm="onUserConfirm"
    ></UserPicker>
  </div>
</template>
<style scoped>
.selected {
  color: #333;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}

.cell-img {
  width: 48px;
  height: 48px;
  float: left;
  border-radius: 50%;
  margin-right: 15px;
}


</style>
<script>
import Vue from 'vue';
import {
  Cell,
  Field,
  Area,
  DatetimePicker,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Dialog,
  Button,
  Calendar
} from 'vant';
import UserPicker from "../../../components/picker/UserPicker";

Vue.use(Cell).use(CellGroup).use(DatetimePicker).use(Calendar).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Dialog).use(Button);
export default {
  name: 'QcxjDetailCommunityAdd',
  components: {
    UserPicker,
  },
  data: function () {
    return {
      showDate: false,
      showUserPicker: false,
      saveLoading: false,
      showPicker: false,

      formData: {
        user: [],
        typeName: '管理员',
        center_id: undefined,
        user_id: undefined,
        type: 2,
      },

      // typeColumns: ['管理员', '教练员', '会员'],
      typeColumns: ['管理员', '教练员'],

      list: []
    }
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = "新增成员"

    that.formData.center_id = this.$route.query.id || 0;
  },
  watch: {},
  destroyed() {
  },
  methods: {
    onUserConfirm(values) {
      console.log('onUserConfirm', [...values])
      this.showUserPicker = false;
      this.formData.user = [...values];
    },

    onUserChange(values) {
      console.log('onUserChange', values)
      this.formData.user = [...values];
    },

    onConfirm(value) {
      console.log(value)
      let type = '';
      switch (value) {
        case '管理员':
          type = 2;
          break;
        case '教练员':
          type = 3;
          break;
        case '会员':
          type = 9;
          break;
      }

      this.formData.type = type
      this.formData.typeName = value
      this.showPicker = false;
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      if(!that.formData.user.length) {
        Toast('请先选择用户')
        return
      }

      that.saveLoading = true;
      that.formData.user_id = that.formData.user[0].id

      that.$api.post('/api/examecenter/centerUserAdd', that.formData, (res) => {
        that.saveLoading = false;
        Toast.success('保存成功')
        rbLink({
          'name': 'QcxjDetailCommunity',
        }, 'back')
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })


    },

  }
}
</script>



// WEBPACK FOOTER //
// QcxjDetailCommunityAdd.vue?2f9b32b4